<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择核销状态" size="small">
                        <el-option label="不限制核销状态" value=""></el-option>
                        <el-option label="仅看未核销的" :value="0"></el-option>
                        <el-option label="仅看核销中的" :value="1"></el-option>
                        <el-option label="仅看核销成功的" :value="2"></el-option>
                        <el-option label="仅看核销失败的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.serialNo" placeholder="请输入兑换流水号" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.contractName" placeholder="请输入合约名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.rightsName" placeholder="请输入权益名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="兑换人ID" :value="1"></el-option>
                            <el-option label="兑换人昵称" :value="2"></el-option>
                            <el-option label="兑换人手机号" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.expressStatus" placeholder="请选择发货状态" size="small">
                        <el-option label="不限制发货状态" value=""></el-option>
                        <el-option label="仅看未发货的" :value="0"></el-option>
                        <el-option label="仅看已发货的" :value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.rightsType" size="small">
                        <el-option label="不限制权益类型" value=""></el-option>
                        <el-option label="仅看实物的" :value="1"></el-option>
                        <el-option label="仅看其他的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="兑换时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/nft/exportExchangeList')"
                type="primary"
                icon="el-icon-download"
                @click="download"
                size="small"
                :loading="downLoading"
                >导出兑换记录</el-button
            >
            <el-button
                v-if="$utils.have('/nft/importExpress')"
                type="primary"
                icon="el-icon-position"
                @click="$refs.batchDeliver.show()"
                size="small"
                >批量发货</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="serialNo" label="兑换流水号" show-overflow-tooltip min-width="100"></el-table-column>
                <el-table-column prop="exchangeTime" label="兑换时间" min-width="150"></el-table-column>
                <el-table-column prop="status" label="核销状态" min-width="90">
                    <template slot-scope="scope">{{status[scope.row.status]}}</template>
                </el-table-column>
                <el-table-column label="兑换人">
                    <el-table-column prop="exchangeUserId" label="ID" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="exchangeUserName" label="昵称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="exchangeUserTelephone" label="手机号" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column prop="contractName" label="合约名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.contractId" :href="`/nftManage/contract/edit/${scope.row.contractId}`" type="primary" class="ellipsis">
                            {{scope.row.contractName}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="rightsName" label="兑换权益" show-overflow-tooltip></el-table-column>
                <el-table-column prop="rightsTypeName" label="权益所属类型" min-width="100"></el-table-column>
                <el-table-column prop="rightsNumber" label="兑换编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="address" label="收货地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="express" label="发货信息" show-overflow-tooltip min-width="100"></el-table-column>
                <el-table-column fixed="right" label="操作" width="90">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/nft/afreshExchange') && scope.row.status == 3"
                            type="text"
                            size="small"
                            @click="afreshExchange(scope.row)"
                            >重新核销</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <BatchDeliver ref="batchDeliver" @onUpdate="getDataList"></BatchDeliver>
    </div>
</template>
<script>
import BatchDeliver from './components/batchDeliver';
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
    endTime:"",//	结束时间
    startTime:"",//	开始时间
    id:"",//	nftId
    contractName:"", //合约名称	
    searchType: 1, //搜索条件类型 1：转赠人ID 2：转赠人昵称 3：转赠人手机号 4：受赠人ID 5：受赠人昵称 6：受赠人手机号
    searchValue: "", //搜索值	
    serialNo:"",//	流水号
    rightsName: "", //权益名称	
    timeType: 1,
    status: "", //核销状态 不限制则传空 0:未核销 1:核销中 2:核销成功 3:核销失败
    expressStatus: "",//发货状态 为空不限制 0:未发货 1:已发货
    rightsType: "",//权益类型 为空不限制 1:实物 2:其他	
}
export default {
    components:{BatchDeliver},
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                startTime: this.$route.query.startTime || '',
                endTime: this.$route.query.endTime || '',
                timeType: parseInt(this.$route.query.timeType || 1),
                id: this.$route.query.id || '',
                contractName: this.$route.query.contractName || '',
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                serialNo: this.$route.query.serialNo || '',
                rightsName: this.$route.query.rightsName || '',
                status: parseInt(this.$route.query.status) || "",
                expressStatus: parseInt(this.$route.query.expressStatus) || "",
                rightsType: parseInt(this.$route.query.rightsType) || "",
            },
            listLoading: true,
            datetimerange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],
            downLoading:false,
        }
    },
    computed:{
        status(){
            return{
                0:'未核销', 1:'核销中', 2:'核销成功', 3:'核销失败'
            }
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/nft/exchangeList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出
        async download() {
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url:'/nft/exportExchangeList',
                method: 'post',
                data: {
                    ...this.params,
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,`${this.$utils.formatDate(Date.now(), 'yyyy-MM-dd HH:ss:mm')}_藏品兑换记录.xlsx`);
            this.downLoading = false;
        },
        //重新核销
        afreshExchange(item){
            const confirmMsg = `确定要重新核销吗？`
            this.$confirm(confirmMsg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // type: 'warning',
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
            }).then(() => {
                this.$request({
                    url: "/nft/afreshExchange",
                    method: "POST",
                    params: {
                        rightsId: item.id,
                    },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            }).catch(() => {});
        }
    }
}
</script>
<style lang="scss" scoped>

</style>